<template>
    <VoKasutajaInfo v-if="vatekSisselogimine" :loading="loading" :kasutajaTaisNimi="taisNimi" :kasutajaInitsiaalid="initsiaalid">
        <template v-slot:logOutNupp>
            <v-row no-gutters>
                <v-col>
                    <v-btn class="text-subtitle-1 px-2 me-8" @click="backToVatek" variant="tonal">
                        Mine VaTeK avalehele
                    </v-btn>
                    <v-btn class="text-subtitle-1 px-2 me-n2" @click="logoutVatek" variant="text" prepend-icon="mdi-logout">
                        Logi välja KRHP-st ja VaTeK-ist
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </VoKasutajaInfo>
    <VoKasutajaInfo v-else :loading="loading" :kasutajaTaisNimi="taisNimi" :kasutajaInitsiaalid="initsiaalid" @logi-valja="logiValja" class="ma-0" />
</template>

<style scoped></style>

<script lang="ts">
import { AuthTeenus } from '@/core/auth-teenus';
import { mapState, mapActions } from 'pinia';
import { useKasutajaStore } from '@/stores/kasutajaStore';
import { defineComponent } from 'vue';
import { useAmetnikStore } from '@/stores/ametnikStore';
import { useTeavitusedStore } from '@/stores/teavitusedStore';
import { useTegevusedStore } from '@/stores/tegevusedStore';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';
import authSchema from "@/constants/authSchema";

const _authTeenus = new AuthTeenus();

export default defineComponent({
    name: 'KasutajaInfo',
    data() {
        return {
            loading: false,
        };
    },
    mounted() {
        if (!this.kasutaja) {
            this.loading = true;
        }
    },
    watch: {
        kasutaja(uus) {
            this.loading = !uus;
        }
    },
    computed: {
        ...mapState(useKasutajaStore, ['kasutaja']),
        taisNimi(): string {
            return `${this.kasutaja?.firstName} ${this.kasutaja?.lastName}`;
        },
        initsiaalid(): string {
            return `${this.kasutaja?.firstName?.substring(0, 1)}${this.kasutaja?.lastName?.substring(0, 1)}`;
        },
        vatekSisselogimine(): boolean {
          return this.kasutaja?.sisselogimisSchema === authSchema.aup3Vatek;
        }
    },
    methods: {
        ...mapActions(useKasutajaStore, ['eemaldaKasutaja']),
        ...mapActions(useAmetnikStore, ['eemaldaAmetnik']),
        ...mapActions(useTeavitusedStore, ['eemaldaTeavitused']),
        ...mapActions(useTegevusedStore, ['eemaldaTegevused']),
        ...mapActions(useUldkasulikTooStore, ['eemaldaUldkasulikToo']),

        logiValja() {
            this.eemaldaKasutaja();
            this.eemaldaAmetnik();
            this.eemaldaTeavitused();
            this.eemaldaTegevused();
            this.eemaldaUldkasulikToo();
            _authTeenus.logiValja();
        },
        backToVatek(): void {
            this.eemaldaKasutaja();
            _authTeenus.backToVatek();
        },
        logoutVatek(): void {
            this.eemaldaKasutaja();
            _authTeenus.logoutVatek();
        }
    }
});
</script>